<template>
  <UserFavourites v-slot="{ refetch, currentUser, favouritesCount }">
    <div class="inline-block md:hidden px-4">
      <button
        class="relative text-[28px] text-black no-outline"
        @click="refetch() && $refs.drawer.set(true)"
        aria-label="Favourites"
      >
        <img src="@/assets/icons/heart.svg" class="w-[20px] mt-2" alt="Favourites" />

        <span
          class="bg-grey-dark text-xs text-white rounded-full absolute right-[-9px] top-[-2px] w-6 h-6 md:w-8 md:h-8 flex justify-center items-center"
          v-if="favouritesCount > 0 && !currentUser"
        >
          {{ favouritesCount }}
        </span>
      </button>

      <Drawer ref="drawer" :onboardPath="onboardPath" :checkoutPath="checkoutPath" />
    </div>
  </UserFavourites>
</template>

<script>
import Drawer from "./FavouriteDrawer.vue"
import UserFavourites from "@/components/UserFavouritesRenderless.js"

export default {
  name: "Nav.Favourite",
  props: {
    onboardPath: {
      type: String,
      required: true,
    },
    checkoutPath: {
      type: String,
      required: true,
    },
  },
  components: {
    Drawer,
    UserFavourites,
  },
  mounted() {
    const ssrNavFavourite = document.getElementById("ssr-nav-favourite")
    ssrNavFavourite.classList.add("hidden")
  },
}
</script>
